var Shariff = require('shariff');
var buttonsContainer = document.querySelector('.t3m-Shariff');
new Shariff(buttonsContainer, {
  orientation: 'horizontal'
});
